import React from "react";
import TopNavbar from "../Components/TopNavbar";
import HeroSection from "../Components/Landingpage/HeroSection";
// import CourseCard from "../Components/LandingPage/CourseCards";
import CourseItems from "../Components/Landingpage/CourseItems";
import Contact from "../Components/Landingpage/Contact";
import Partners from "../Components/Landingpage/Partners";
import TalentsCompany from "../Components/Landingpage/TalentsCompany";
import Footer from "../Components/Footer";
import Testimonials from "../Components/Landingpage/Testimonials";
import FAQs from "../Components/Landingpage/Faqs";
import WhyChooseUs from "../Components/Landingpage/WhyChoose";

const Home = () => {
  return (
    <>
      <TopNavbar />
      <HeroSection />
      <Partners />
      {/* <CourseCard /> */}
      <CourseItems />
      <WhyChooseUs />
      <FAQs />
      <Testimonials />
      <TalentsCompany />
      <Contact />
      <Footer />
    </>
  );
};

export default Home;
